import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const loadingShell = (
  <div className="page-container">Loading...</div>
)

/**
 * Central auth gate for routes: one loading shell and shared redirect rules.
 * @param {'requireAuth' | 'guestOnly' | 'admin'} mode
 * @param {React.ReactNode} children
 */
function AuthGate({ mode, children }) {
  const { isAuthenticated, user, isLoading } = useAuth()

  if (isLoading) {
    return loadingShell
  }

  if (mode === 'guestOnly') {
    if (isAuthenticated) {
      return <Navigate to="/dashboard" replace />
    }
    return children
  }

  if (mode === 'requireAuth') {
    if (!isAuthenticated) {
      return <Navigate to="/" replace />
    }
    return children
  }

  if (mode === 'admin') {
    if (!isAuthenticated) {
      return <Navigate to="/" replace />
    }
    if (user?.role !== 'admin') {
      return <Navigate to="/dashboard" replace />
    }
    return children
  }

  return children
}

export default AuthGate
